import { usePage } from "@inertiajs/react";
import Container from "hardcover-ui/components/Container";
import useIsLoggedIn from "hooks/user/useIsLoggedIn";
import { BookPageProps } from "pages/clientverse/books/show.props";
import FollowingReviews from "./FollowingReviews";
import PopularReviews from "components/books/PopularReviews";
import SimilarUserReviews from "./SimilarUserReviews";
import { PageSerializersBooksShow } from "types/serializers";

export default function TopBookReviews({ book }: { book: PageSerializersBooksShow; }) {
  const isLoggedIn = useIsLoggedIn();
  const { reviews } = book;
  const { networkActivity } = usePage<BookPageProps>().props;

  return (
    <Container variant="layout" size="md">
      <h2 className="sr-only">Reviews</h2>
      <div className="mt-4">
        <PopularReviews book={book} reviews={reviews} />

        {isLoggedIn ? (
          <>
            <FollowingReviews reviews={networkActivity.followingReviews} book={book} exclude={reviews} />
            <SimilarUserReviews reviews={networkActivity.similarReviews} book={book} exclude={[...networkActivity.followingReviews, ...reviews]} />
          </>
        ) : (
          <></>
        )}
      </div>
    </Container>
  );
}
